export default __webpack_public_path__ + "assets/fonts/d7d4ef8386e77e7a0bce8f00e9df8cd4.woff";